export default "__VITE_ASSET__EPg1IQg8__"